// @ts-ignore
import * as Locale from '../locale/PT-BR.json'

const ErrorMessage = (request) => {
  let message: String = Locale.default._.request

  if (request && request.response && request.response.data) {
    const data = request.response.data

    if (data && data.errors && data.errors.length > 0) {
      message = data.errors[0].message
    } else if (data && data.message) {
      message = data.message
    } else {
      message = Locale.default._.request
    }
  } else {
    message = Locale.default._.request
  }

  return message
}

export default ErrorMessage
